import { Stocktake_Item } from "../../models/RestModels";

export function getEmptyStocktakeItem(): Stocktake_Item
{
		return {
			created: new Date(),
			created_by_user_id: 0,
			db_qty: 0,
			item_id: 0,
			real_qty: 0,
			stocktake_id:0,
			updated: new Date(),
			updated_by_user_id: null,
		}
}
